import React, { useEffect } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components/macro";

import { closeConfirmModal } from "actions";

import { Button, DeleteButton, SecondaryButton } from "components/Form";
import { Column } from "components/Layout";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "components/MaterialDialog";

import NLISLogo from "img/NLIS-logo.png";

const SubmittingWrapper = styled.div`
  padding: ${({ theme }) => theme.space[4]}px;
`;

const SubmittingText = styled.div`
  text-align: center;
  margin-top: ${({ theme }) => theme.space[3]}px;
`;

const NLISImg = styled.img.attrs({
  src: NLISLogo,
  alt: "Submitting Transfer",
})`
  display: flex;
  margin: auto;
`;

const ConfirmModalContainer = () => {
  const dispatch = useDispatch();
  const isOpen: boolean = useSelector(
    (state: RootState) => state.modals.context.confirmModal.isOpen,
  );
  const modalProps = useSelector(
    (state: RootState) => state.modals.context.confirmModal.modalProps,
  );

  const {
    title,
    message,
    actions = [],
    timeOut,
    maxWidth = "sm",
    nlisSubmitting,
    icon = null,
    color = null,
  } = modalProps || {};

  const onClose = () => dispatch(closeConfirmModal());

  useEffect(() => {
    if (timeOut) {
      setTimeout(() => {
        onClose();
      }, timeOut);
    }
  });

  return isOpen ? (
    <Dialog open={!!isOpen} onClose={onClose} maxWidth={maxWidth} fullWidth>
      <DialogTitle onClose={onClose}>
        {icon && <FontAwesomeIcon icon={icon} color={color} />}
        {title}
      </DialogTitle>
      <DialogContent dividers form>
        <Column padding={2}>
          {nlisSubmitting ? (
            <SubmittingWrapper>
              <NLISImg />
              <SubmittingText>
                <h4>Submitting Transfer</h4>
              </SubmittingText>
            </SubmittingWrapper>
          ) : (
            <div style={{ whiteSpace: "pre-line" }}>{message}</div>
          )}
        </Column>
      </DialogContent>
      <DialogActions>
        {actions.map(
          ({ dataTour, label, onClick, secondary, destructive, onClickAction }) => {
            const dispatchOnClickAction = () => {
              if (typeof onClickAction === "function") {
                dispatch(onClickAction());
              }
            };
            if (secondary) {
              return (
                <SecondaryButton
                  key={label}
                  data-tour={dataTour || label}
                  onClick={
                    typeof onClick === "function"
                      ? onClick
                      : dispatchOnClickAction
                  }
                >
                  {label}
                </SecondaryButton>
              );
            }
            if (destructive) {
              return (
                <DeleteButton
                  key={label}
                  data-tour={dataTour || label}
                  onClick={
                    typeof onClick === "function"
                      ? onClick
                      : dispatchOnClickAction
                  }
                >
                  {label}
                </DeleteButton>
              );
            }
            return (
              <Button
                key={label}
                data-tour={dataTour || label}
                onClick={
                  typeof onClick === "function"
                    ? onClick
                    : dispatchOnClickAction
                }
              >
                {label}
              </Button>
            );
          },
        )}
      </DialogActions>
    </Dialog>
  ) : null;
};

export default ConfirmModalContainer;
